<template>
    <div class="w-full">
        <div class="w-full flex">
            <div v-for="(step, index) in steps" :key="index" class="flex flex-grow">
                <div
                    v-if="index > 0"
                    class="h-2 w-full my-auto mr-4 rounded-r-full"
                    :class="index <= currentStep ? 'bg-lightblue-500' : 'bg-gray-300'"
                ></div>

                <div class="flex-shrink-0">
                    <div
                        :class="index <= currentStep ? 'bg-lightblue-500' : 'bg-gray-300'"
                        class="w-12 h-12 mx-auto rounded-full text-gray-50 flex"
                        @click="handleItemClick(index)"
                    >
                        <fa-icon :icon="step.icon" class="m-auto text-xl"></fa-icon>
                    </div>
                    <fa-icon
                        v-if="step.hasIssue ? step.hasIssue : false"
                        icon="exclamation-triangle"
                        class="flex text-red-500 ml-auto -mt-4 -mr-2"
                    ></fa-icon>
                </div>

                <div
                    v-if="index < steps.length - 1"
                    class="h-2 w-full my-auto ml-4 rounded-l-full"
                    :class="index < currentStep ? 'bg-lightblue-500' : 'bg-gray-300'"
                ></div>
            </div>
        </div>

        <div class="w-full flex mt-1">
            <div v-for="(step, index) in steps" :key="index" class="flex flex-grow">
                <p
                    class="text-sm text-gray-400"
                    :class="{
                        'ml-auto': index > 0,
                        'mr-auto': index < steps.length - 1,
                        'text-gray-700': index === currentStep,
                    }"
                >
                    {{ $t(step.text) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import FaIcon from "@/Components/FaIcon";

export default {
    components: {
        FaIcon,
    },
    props: {
        steps: {
            type: Array,
            required: true,
        },
        currentStep: {
            type: Number,
            required: true,
        },
        allowItemNavigation: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["item-click"],
    methods: {
        handleItemClick(index) {
            if (!this.allowItemNavigation) return;

            this.$emit("item-click", index);
        },
    },
};
</script>
